export default __webpack_public_path__ + "static/media/Harness of the Haunter in the Dark.3d1f0e5f.jpg";